export const API_URL = 'https://api-erp.milvendas.ao/api';